// extracted by mini-css-extract-plugin
module.exports = {"tab":"rules_tab__12VXz","sup":"rules_sup__99Gxc"};